import { render, staticRenderFns } from "./FaqList.vue?vue&type=template&id=702b1894&scoped=true&"
import script from "./FaqList.vue?vue&type=script&lang=js&"
export * from "./FaqList.vue?vue&type=script&lang=js&"
import style0 from "./FaqList.vue?vue&type=style&index=0&id=702b1894&lang=scss&scoped=true&"
import style1 from "./FaqList.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "702b1894",
  null
  
)

export default component.exports